import { type MouseEvent as ReactMouseEvent } from 'react';
import { useNavigate } from 'react-router';
import { EditPencilIcon } from '~/images/icons';
import ArrowDownIcon from '~/images/icons/ArrowDown';
import BulbIcon from '~/images/icons/BulbIcon';
import { Colors } from '~/themes/colors';
import { Center } from '../Center';
import { Column } from '../Column';
import { Row } from '../Row';
import { Text } from '../Text';

interface IBackTipsProps {
  date: Date;
  onReturnClick(e: ReactMouseEvent<HTMLDivElement>): void;
}

export const BackTips = ({ date, onReturnClick }: IBackTipsProps) => {
  const navigate = useNavigate();

  const handleEditClick = () =>
    navigate('/dashboard/multi-day/edit', {
      state: { editedDate: date, defaultOpenCardIndex: 'rate' },
    });

  return (
    <Column backgroundColor={Colors.secondary_25} borderRadius={8} height="100%" width="100%">
      <Row
        alignItems="center"
        justifyContent="space-between"
        paddingBottom={12}
        paddingInline={16}
        paddingTop={18}
      >
        <Row
          alignItems="center"
          justifyContent="space-between"
          borderBottomWidth={1}
          borderBottomStyle="solid"
          borderBottomColor={Colors.neutral_100}
          paddingBottom={6}
          paddingRight={12}
          width="100%"
        >
          <Row alignItems="center" cursor="pointer" onClick={onReturnClick}>
            <Center transform="rotate(90deg)">
              <ArrowDownIcon />
            </Center>
            <Text
              bold
              color={Colors.secondary_500}
              fontSize={18}
              marginLeft={10}
              textTransform="capitalize"
            >
              Return
            </Text>
          </Row>
          <Row alignItems="center" gap={4}>
            <BulbIcon color={Colors.secondary_500} />
            <Text bold color={Colors.primary_500} fontSize={18} marginTop={4}>
              Tips!
            </Text>
          </Row>
        </Row>
      </Row>

      <Column paddingRight={20} paddingLeft={24} gap={2}>
        <Text marginTop={2}>
          Boost your chances of filling this shift! We recommend increasing the hourly rate beyond
          the industry average on shifts posted within <strong>36 hours</strong> from its starting
          time.
          <br />
          Click “Edit” to bump the rate higher.
        </Text>
      </Column>

      <Row
        bottom={24}
        cursor="pointer"
        gap={4}
        position="absolute"
        right={32}
        onClick={handleEditClick}
      >
        <EditPencilIcon color={Colors.secondary_500} />
        <Text color={Colors.secondary_500} fontSize={18}>
          Edit
        </Text>
      </Row>
    </Column>
  );
};
